<template>
    <div class="form">
        <h4 class="step-title">
            Any claims in the past 5 years?
        </h4>
        <div class="step-content d-flex flex-column align-items-center">
            <scrollable-button-list v-bind:items="claimTypes" v-bind:onclick="complete" v-bind:value="lead.homeInsurance.claimsInPast5Years"/>
        </div>
    </div>
</template>

<script>
    import ScrollableButtonList from "../shared/ScrollableButtonList.vue"

    export default {
        name: "HomeClaimsInPast5Years",
        components: {
            ScrollableButtonList
        },
        data: function() {
            return {
                claimTypes: [
                    { text: "Yes", value: "1" },
                    { text: "No", value: "0" }
                ]
            }
        },
        props: {
            lead: Object
        },
        methods: {
            complete: function(value) {
                this.lead.homeInsurance.claimsInPast5Years = value;
                this.$emit("complete", this.$options.name, value);
            }
        }
    }
</script>
